import React, { useState } from "react";
import { X, Receipt, Calendar, Wallet } from "lucide-react";
import { toast } from "react-toastify";

const API_BASE =
  "https://receivablesbackend.onrender.com/api";

const NewInvoiceModalModern = ({
  isOpen,
  onClose,
  client,
  onSuccess,
}) => {

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    item: "",
    amount: "",
    due_date: "",
  });

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.item ||
      !formData.amount ||
      !formData.due_date
    ) {
      toast.error("Complete all fields.");
      return;
    }

    const payload = {
      pos_customer_id: Number(client.id),

      item: formData.item,

      amount: Number(formData.amount),

      due_date: formData.due_date,

      status: "Pending",

      invoice_number:
        `INV-${Date.now()}`,

      outstanding_amount:
        Number(formData.amount),
    };

    try {

      setLoading(true);

      const res = await fetch(
        `${API_BASE}/invoices`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        throw new Error();
      }

      toast.success("Invoice created.");

      onSuccess();

      onClose();

    } catch (err) {

      toast.error("Failed to create invoice.");

    } finally {

      setLoading(false);

    }
  };

  return (
    <div className="modern-modal-overlay">

      <div className="modern-modal">

        <div className="modern-modal-header">

          <div>
            <h2>Create Invoice</h2>
            <p>{client.name}</p>
          </div>

          <button
            className="close-btn"
            onClick={onClose}
          >
            <X size={18} />
          </button>

        </div>

        <form
          onSubmit={handleSubmit}
          className="modern-form"
        >

          <div className="modern-input-group">

            <label>
              <Receipt size={16} />
              Description
            </label>

            <input
              type="text"
              placeholder="Invoice description"
              value={formData.item}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  item: e.target.value,
                })
              }
            />

          </div>

          <div className="modern-input-group">

            <label>
              <Wallet size={16} />
              Amount
            </label>

            <input
              type="number"
              placeholder="0.00"
              value={formData.amount}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  amount: e.target.value,
                })
              }
            />

          </div>

          <div className="modern-input-group">

            <label>
              <Calendar size={16} />
              Due Date
            </label>

            <input
              type="date"
              value={formData.due_date}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  due_date: e.target.value,
                })
              }
            />

          </div>

          {/* LIVE PREVIEW */}

          <div className="invoice-preview-card">

            <span>Invoice Preview</span>

    <strong>
  $
  {Number(formData.amount || 0).toLocaleString(
    "en-US",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  )}
</strong>

            <p>
              {formData.item || "No description"}
            </p>

          </div>

          <button
            type="submit"
            className="submit-modern-btn"
            disabled={loading}
          >
            {
              loading
                ? "Creating..."
                : "Create Invoice"
            }
          </button>

        </form>

      </div>

    </div>
  );
};

export default NewInvoiceModalModern;